module.exports = __webpack_public_path__ + "img/ireland.e97f07e6.svg";